
import { useEffect, useRef } from "react";

const Barchart = ({chartData}) => {
  const ref = useRef();

  useEffect(() => {
    
    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/@chartshq/muze@2.0.0/dist/muze.js";
    script.async = true;
    script.onload = () => scriptLoaded();

    document.body.appendChild(script);

  }, []);
  let scriptLoaded = async () => {
    
    const muze = window.muze;
    let schema = [
      // {
      //   name: 'Micro Market',
      //   type: 'dimension'
      // },
      // {
      //   name: 'Market',
      //   type: 'dimension'
      // },
      // {
      //   name:'value',
      //   type:'measure'
      // }
      // {
      //   name: 'Horsepower',
      //   type: 'measure',
      //   defAggFn: 'avg'
      // },
      // {
      //   name: 'Origin',
      //   type: 'dimension'
      // }
    ]
    let cols = [];
    for(let i=0; i< chartData.cols.length; i++) {
      schema.push({name:chartData.cols[i].display_name, type:'dimension'})
      cols.push(chartData.cols[i].display_name);
    }

    for(let i=0; i< chartData.rows.length; i++) {
      schema.push({name:chartData.rows[i].display_name, type:'dimension'})
      cols.push(chartData.rows[i].display_name);
    }
    schema.push({name:"value", type:"measure"});
    console.log(schema);
    // Prepare the data.

    
    let data = chartData.data;
    console.log(data);
    const DataModel = await muze.DataModel.onReady();
  
  // Converts the raw data into a format
  // which DataModel can consume.
  const formattedData = await DataModel.loadData(data, schema);

  // Create a new DataModel instance with
  // the formatted data.
  let dm = new DataModel(formattedData);
  console.log(dm);
  // Create a global environment to share common configs across charts.
  const env = await muze();
  for (var prop in env) {
    console.log(prop); // This will print 'a' in your case
  }
  
  // Create a new canvas instance from the global
  // environment to render chart on.
  console.log(env.canvas().layers);
  env.canvas()
  const canvas = env.canvas();
  
  
  env.canvas()
  .data(dm) // Set data to the chart.
  .rows(["value",]) // Fields drawn on Y axis.
  .columns(cols) 
  .layers([{
    mark: 'line',
    //transform: { type: 'stack' }
  }])// Fields drawn on X axis.
  .mount("#chart"); // Specify an element to mount on using a CSS selector.
  
    
  }
  return (<div id="chart" style={{height:500}}></div>);
  //return Plotly.newPlot('3723', fig, {showSendToCloud: true});;
};

export default Barchart;